module.exports = __webpack_public_path__ + "static/media/okra.ce9b2eda.png";